import React, { useContext, useEffect } from 'react';

import CartEventsContext from '../../../common/contexts/CartEventsContext';
import LocResourcesContext from '../../../common/contexts/LocResourcesContext';

import DonationArticle from './DonationArticle';

interface DonationListProps {
}

const DonationList = ({ }: DonationListProps): JSX.Element => {
  const GLOBAL_PREFIX = 'loy-bp-rws-donations';
  const { onFormatLocale } = useContext(LocResourcesContext);
  const { donationArticles } = useContext(CartEventsContext);

  useEffect(() => {
    const donations = document.getElementsByClassName(GLOBAL_PREFIX)[0];
    if (donations) {
      const donationsList = donations.getElementsByClassName(GLOBAL_PREFIX + '__articles')[0];
      const donationsListFirstChild = donationsList
        ? donationsList.getElementsByTagName('li')[0]
        : null;
      const setWhiteGradientLeft = () => {
        if (donationsListFirstChild && donationsListFirstChild.getBoundingClientRect().left > 0) {
          donations.classList.add('is-reset');
        } else {
          donations.classList.remove('is-reset');
        }
      };
      donations.addEventListener('touchend', setWhiteGradientLeft);
      return function cleanUp() {
        donations.removeEventListener('touchend', setWhiteGradientLeft);
      };
    }
    return () => {};
  }, []);

  return donationArticles && donationArticles.length > 0 ? (
    <React.Fragment>
      <div className={`${GLOBAL_PREFIX}__title`}>
        {onFormatLocale?.('loy.rewards.shop.donate.title')}
      </div>
      <div className={`${GLOBAL_PREFIX} is-reset`}>
        <ul className={`${GLOBAL_PREFIX}__articles`}>
          {donationArticles?.map((article) => {
            return <DonationArticle
              article={article}
              quantityInCart={article.quantityInCart ?? 0}
            />;
          })}
        </ul>
      </div>
    </React.Fragment>
  ) : (
    <></>
  );
};

export default DonationList;
